import { CookiesName } from '@/api';
import { useCookies } from 'vue3-cookies';
import { TLoginApiResponse } from '@/types/users/index';
import { useTemplateRef } from 'vue'

const { cookies } = useCookies();

/** Validation */
export const validators = {
  email: (v: string) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(v) || 'Please enter a valid email address';
  },
  password: (v: string) => {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{8,64}$/;
    return pattern.test(v) || 'Пароль должен содержать минимум 8 символов, хотябы одну заглавную букву, одну строчную букву и одну цифру.';
  },
  arrayHasItems: (v: any) => !!v && Array.isArray(v) && v?.length > 0 || 'This field is required',
  required: (v: any) => !!v || 'This field is required',
  minLength: (v: any, length: number) => v.length >= length || `Минимальная длина поля ${length} символов`,
  maxLength: (v: any, length: number) => v.length <= length || `Максимальная длина поля ${length} символов`,
};

export const setAllCookies = (response: TLoginApiResponse) => {
  cookies.set(CookiesName.token, response.jsonWebToken);
  cookies.set(CookiesName.refreshToken, response.refreshToken);
  cookies.set(CookiesName.tokenExpiresAt, response.jsonWebTokenExpiresAt);
  cookies.set(
    CookiesName.refreshTokenExpiresAt,
    response.refreshTokenExpiresAt,
  );
};

export const removeAllCookies = () => {
  cookies.remove(CookiesName.token);
  cookies.remove(CookiesName.refreshToken);
  cookies.remove(CookiesName.tokenExpiresAt);
  cookies.remove(CookiesName.refreshTokenExpiresAt);
};

export const tokenIsValid = () => {
  const token = cookies.get(CookiesName.token);
  const tokenExpiresAt = cookies.get(CookiesName.tokenExpiresAt);
  return !!token && !!tokenExpiresAt && new Date(tokenExpiresAt).getTime() > Date.now();
};

export const refreshTokenIsValid = () => {
  const token = cookies.get(CookiesName.refreshToken);
  const tokenExpiresAt = cookies.get(CookiesName.refreshTokenExpiresAt);
  return !!token && !!tokenExpiresAt && new Date(tokenExpiresAt).getTime() > Date.now();
};

export const useMultipleTemplateRefs = (names: string[]) => {
  return names.map((name) => useTemplateRef(name))
}